<template>
  <div v-if="loading">
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
  </div>
  <div v-else>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        formDataId: this.id,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
      v-on:new="createHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import StatutoryReportForm from "../../../components/payroll/statutoryreportsetup/FormNew";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    "app-form": StatutoryReportForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
    Loading
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setupbaitulmal.editstatutorysetup'),
      pageTitleValue: "",
      formData: {
        id: null,
        startdate: null,
        enddate: null,
        userid: this.$store.getters.userId,
        stamp: null,
      },
      loading: false,
      editMode: true,

      errMsg: "",
      isErr: false,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    //load statutory report by id
    async loadStatutoryReport() {
      if (this.id === null || this.id === 0) {
        this.isErr = true;
        this.errMsg = "Invalid ID";
        return;
      }

      try {
        const res = await this.$store.dispatch("get", {
          url: "/statutoryreportsetup/" + this.id,
        });

        if (res.data.error) {
          this.isErr = true;
          this.errMsg = res.data.error;
          return;
        }

        if (!res.data.rec || res.data.rec.length === 0) {
          this.isErr = true;
          this.errMsg = "Record not found";
          return;
        }

        this.formData = res.data.rec[0];

        if (this.formData.startdate) {
          this.formData.startdate = moment(this.formData.startdate).format("YYYY-MM-DD");
        }

        if (this.formData.enddate) {
          this.formData.enddate = moment(this.formData.enddate).format("YYYY-MM-DD");
        }

        this.formData.userid = this.$store.getters.userId;
      } catch (err) {
        this.isErr = true;
        this.errMsg = err;
      }
    },

    saveHandler() {
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) return false;

      const payload = {
        startdate: this.formData.startdate,
        enddate: this.formData.enddate,
        userid: this.formData.userid,
        stamp: this.formData.stamp
      };
      this.$store.dispatch('put', { url: "/statutoryreportsetupNew/" + this.id, payload: payload })
        .then(res => {
          if (res.data.error) {
            this.isErr = true;
            this.errMsg = res.data.error;
            return;
          }
          // update local stamp from server
          if (res.data.stamp !== undefined) this.formData.stamp = res.data.stamp;
          this.$router.push({ name: "statutoryreportsetuplist", params: { search: this.search }});
        })
        .catch(err => {
          this.isErr = true;
          this.errMsg = err.response?.data?.error || err.message;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/statutoryreportsetup/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "statutoryreportsetuplist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "statutoryreportsetuplist" });
    },

    createHandler() {
      this.$router.push({ name: "statutoryreportsetupnew_new" });
    },
  },

  async mounted() {
    this.loading = true;
    await this.loadStatutoryReport();
    this.loading = false;
  },
};
</script>